import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CbFontWeightOpenSansBold } from '@coolblue-development/design-tokens';
import { Box, Divider, Drawer, DrawerBody, Flex, freddyTheme, Link, Typography, } from '@coolblue-development/freddy';
import openAccountTrigger from '@coolblue-development/ga4-events/triggers/Account/openAccountTrigger';
import selectNavigationTrigger from '@coolblue-development/ga4-events/triggers/Account/selectNavigationTrigger';
import clickLogoutButtonTrigger from '@coolblue-development/ga4-events/triggers/Login/clickLogoutButtonTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useState } from 'react';
import AccountMenuIcon from '../AccountMenuIcon/AccountMenuIcon.js';
import FactSlogan from '../FactSlogan/FactSlogan.js';
import Login from '../Login/Login.js';
function SidePanel({ title, links, isCustomerRecognised, loginUrl }) {
    const { trackEvent } = useAnalytics();
    const [isOpen, setIsOpen] = useState(false);
    const totalLinks = links.length;
    const drawerTranslations = useFreddyTranslations('drawer');
    const trackLinkClick = (index, url, trackingRedirect, isLogout) => {
        if (isLogout) {
            trackEvent(clickLogoutButtonTrigger({
                sub_feature: 'header',
            }));
        }
        else {
            trackEvent(selectNavigationTrigger({
                index,
                total_indices: totalLinks,
                url,
                redirect: trackingRedirect,
            }));
        }
    };
    const menu = links.map((link, index) => {
        return (link.url && (_jsxs(Link, { href: link.url, variant: "subtle", onClick: () => {
                var _a, _b;
                return trackLinkClick(index, link.url, (_a = link.trackingRedirect) !== null && _a !== void 0 ? _a : '', (_b = link.isLogout) !== null && _b !== void 0 ? _b : false);
            }, children: [_jsxs(Flex, { p: 200, justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { m: 0, fontWeight: link.shouldBold ? CbFontWeightOpenSansBold : undefined, children: link.title }), _jsx(ArrowRight, { size: 12, fill: freddyTheme.color.icon.subtle })] }), index !== links.length - 1 && _jsx(Divider, { my: 200 })] }, link.title)));
    });
    const handleClick = () => {
        setIsOpen(true);
        trackEvent(openAccountTrigger({ sub_feature: 'header' }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { onClick: handleClick, component: "button", "aria-label": title, px: 200, sx: {
                    all: 'unset',
                    color: freddyTheme.color.icon.inverse,
                    '&:focus-visible': {
                        outline: 'none',
                        boxShadow: `0 0 0 .2rem ${freddyTheme.color.border.interactiveFocused}`,
                        borderRadius: freddyTheme.borderRadius[100],
                        padding: `${freddyTheme.spacing[0]} ${freddyTheme.spacing[100]}`,
                    },
                }, children: _jsx(AccountMenuIcon, { isCustomerRecognised: isCustomerRecognised }) }), _jsx(Drawer, { open: isOpen, onClose: () => setIsOpen(false), placement: "left", title: title, translations: drawerTranslations, body: _jsx(DrawerBody, { noPadding: true, children: _jsxs(Box, { pt: 200, children: [!isCustomerRecognised && (_jsx(Box, { p: 200, children: _jsx(FactSlogan, { isCustomerRecognised: false }) })), menu, !isCustomerRecognised && loginUrl && (_jsx(Box, { px: 200, children: _jsx(Login, { url: loginUrl }) }))] }) }) })] }));
}
export default SidePanel;
//# sourceMappingURL=SidePanel.js.map